import { http } from '../http';

export async function getSignedDocumentDownloadUrl(documentPath: string) {
	try {
		const signedDocumentDownloadUrl = await http.get<{
			download_url: string | null;
		}>(`documents/download-url?document-path=${encodeURIComponent(documentPath)}`);
		return signedDocumentDownloadUrl?.download_url ?? null;
	} catch (exception) {
		console.debug('GET signed document download url', exception);
		throw exception;
	}
}
